import { FC } from "react";
import ReportLayout from "../../components/Report/ReportLayout";
import { kpiDefinition, reportConsiderations } from "../about/utils";
import { FilterType } from "../../types/filters.types";

interface UnifiedReportProps {
  forceScreen?: "extraSmall" | "mobile" | "desktop";
  canScanBarcode?: boolean;
  loadFilters?: FilterType[];
}

const UnifiedReport: FC<UnifiedReportProps> = ({
  forceScreen,
  canScanBarcode,
  loadFilters,
}) => (
  <ReportLayout
    forceScreen={forceScreen}
    canScanBarcode={canScanBarcode}
    isMainView
    loadFilters={loadFilters}
    kpiDefinition={kpiDefinition.slice(2)}
    reportConsiderations={reportConsiderations.slice(1)}
  />
);

export default UnifiedReport;
